module.exports = __webpack_public_path__ + "static/media/commentaire.45481a35.png";